module.exports = __webpack_public_path__ + "img/clock.dfb3053f.svg";